import Component from "$store/components/ui/SliderJS.tsx";
import type { Props } from "$store/components/ui/SliderJS.tsx";

function Island(props: Props) {
  return <Component {...props} />;
}

export default Island;
